import { useEffect, useState } from "react";
import "../assets/styles/agency-projects.scss";

const EMBED_ORIGIN = "https://webgrowthpros.com";

function AgencyProjects() {
  const [atBottom, setAtBottom] = useState(false);

  useEffect(() => {
    function handleMessage(event) {
      if (event.origin !== EMBED_ORIGIN) return;
      if (event.data && event.data.type === "wgp-embed-scroll") {
        setAtBottom(!!event.data.atBottom);
      }
    }
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <div className="agency-projects container" data-aos="fade-up">
      <div className="agency-projects__header">
        <h2 className="font-weight-bold">Recent Projects</h2>
        <p className="f-text-m">
          A showcase of client websites I've designed and built.
        </p>
      </div>
      <div className="agency-projects__frame-wrap">
        <iframe
          src="https://webgrowthpros.com/embed-projects/"
          title="Project portfolio"
          loading="lazy"
          className="agency-projects__frame"
          allowTransparency="true"
        />
        <div
          className={`agency-projects__fade${atBottom ? " agency-projects__fade--hidden" : ""}`}
        >
          <span>
            Scroll to browse more <i className="fa-solid fa-chevron-down"></i>
          </span>
        </div>
      </div>
      <h3 className="agency-projects__more-title font-weight-bold">More Projects</h3>
      {/* <div className="d-flex justify-content-center pt-5">
        <a
          href="https://webgrowthpros.com/projects/"
          target="_blank"
          rel="noopener noreferrer"
          className="button-50 button"
        >
          View full portfolio &nbsp;<i className="fa-solid fa-arrow-right"></i>
        </a>
      </div> */}
    </div>
  );
}

export default AgencyProjects;
